import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import Brand from '@/components/common/Brand';
import { useAuth } from '@/hooks/use-auth';
import { updateRouterContext } from '@/lib/router/router-utils';

import {
  NAV_ITEMS,
  SIDEBAR_WIDTH,
  SIDEBAR_WIDTH_COLLAPSED,
} from '../../constants/dashboard.constants';
import { useSidebarCollapse } from '../../hooks/useSidebarCollapse';
import { SidebarFooter } from './SidebarFooter';
import { SidebarNavSection } from './SidebarNavSection';

export function Sidebar() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const { isCollapsed, toggleSidebar } = useSidebarCollapse();

  const handleLogout = () => {
    logout();
    updateRouterContext();
    navigate({ to: '/login' });
  };

  const dashboardItems = NAV_ITEMS.filter((item) => item.key === 'dashboard');
  const applicationItems = NAV_ITEMS.filter(
    (item) =>
      item.key === 'pipeline' ||
      item.key === 'forms' ||
      item.key === 'clients' ||
      item.key === 'reports' ||
      item.key === 'notifications'
  );
  const settingsItems = NAV_ITEMS.filter((item) => item.key === 'settings');

  const sidebarWidth = isCollapsed ? SIDEBAR_WIDTH_COLLAPSED : SIDEBAR_WIDTH;

  return (
    <aside
      className={`fixed left-0 top-0 flex h-screen flex-col justify-between bg-surface-inverse py-8 transition-all duration-300 ease-in-out ${
        isCollapsed ? 'px-3' : 'p-5'
      }`}
      style={{ width: sidebarWidth }}
    >
      <div className="flex flex-col gap-8">
        <div className={isCollapsed ? '' : 'px-2'}>
          <Brand
            link="/dashboard"
            variant="light"
            size={isCollapsed ? 'compact' : 'default'}
          />
        </div>

        <nav className="flex flex-col gap-6">
          <SidebarNavSection
            label={t('nav.sections.dashboard')}
            items={dashboardItems}
            isCollapsed={isCollapsed}
          />
          <SidebarNavSection
            label={t('nav.sections.applications')}
            items={applicationItems}
            isCollapsed={isCollapsed}
          />
          <SidebarNavSection
            label={t('nav.sections.settings')}
            items={settingsItems}
            isCollapsed={isCollapsed}
          />
        </nav>
      </div>

      <SidebarFooter
        isCollapsed={isCollapsed}
        onToggleSidebar={toggleSidebar}
        onLogout={handleLogout}
      />
    </aside>
  );
}
